import { BasicModal, Typography } from "@/components";
import { cn } from "@/libraries/cn";
import Button from "@mui/material/Button";
import type { ButtonProps } from "@mui/material/Button";
import type { ModalProps } from "@mui/material/Modal";
import omit from "lodash/omit";
import { forwardRef } from "react";

interface ModalConfirmProps extends Omit<ModalProps, "children"> {
	title: string;
	description?: string;
	positiveButtonProps?: ButtonProps & { label: string };
	negativeButtonProps?: ButtonProps & { label: string };
}

const ModalConfirm = forwardRef<HTMLDivElement, ModalConfirmProps>(
	(
		{
			title,
			description,
			open,
			onClose,
			positiveButtonProps,
			negativeButtonProps,
			...props
		},
		ref,
	) => {
		return (
			<BasicModal isOpen={open} onClose={onClose} {...props}>
				<div ref={ref} className="flex flex-col gap-4">
					<Typography fontWeight={600} fontSize={16} align="center">
						{title}
					</Typography>
					{description ? (
						<Typography fontWeight={400} fontSize={14} align="center">
							{description}
						</Typography>
					) : null}
					{positiveButtonProps ? (
						<Button
							fullWidth
							variant="contained"
							color="primary"
							size="large"
							className={cn("!rounded-full", positiveButtonProps.className)}
							{...omit(positiveButtonProps, ["label", "className"])}
						>
							{positiveButtonProps.label}
						</Button>
					) : null}
					{negativeButtonProps ? (
						<Button
							fullWidth
							variant="outlined"
							color="primary"
							size="large"
							className={cn("!rounded-full", negativeButtonProps.className)}
							{...omit(negativeButtonProps, ["label", "className"])}
						>
							{negativeButtonProps.label}
						</Button>
					) : null}
				</div>
			</BasicModal>
		);
	},
);

ModalConfirm.displayName = "ModalConfirm";

export default ModalConfirm;
